import { spacing } from '@upstox/upstox-ui';

export const ipoLogo: CSSFunction = ({ theme }) => ({
  marginRight: spacing(theme, ['medium']),
});

export const ipoHeader: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['xsmall']),
  '@media (min-width:768px)': {
    marginBottom: spacing(theme, [44]),
  },
});
export const subText: CSSFunction = ({ theme }) => ({
  paddingLeft: spacing(theme, ['xxsmall']),
});
export const ipoText: CSSFunction = ({ theme }) => ({
  width: '100%',
  '& span': {
    wordBreak: 'break-all',
  },
});

export const ipoName: CSSFunction = ({ theme }) => ({
  width: '100%',
  marginBottom: spacing(theme, ['small']),
  '@media(min-width:768px)': {
    width: 'auto',
    marginBottom: spacing(theme, ['none']),
  },
});
